import { cn } from "@/lib/utils";

interface Props {
  ageDays: number;
}

function alderTekst(d: number): string {
  if (d <= 0) return "I dag";
  if (d === 1) return "1 dag";
  return `${d} dager`;
}

/**
 * Liten alder-badge som farges destruktiv hvis oppgaven har ligget ≥ 7 dager.
 * Brukes inline ved ProjectChip på innboks-rader.
 */
export function HastBadge({ ageDays }: Props) {
  const isHast = ageDays >= 7;
  return (
    <span
      className={cn(
        "text-[11px] tabular-nums",
        isHast ? "text-destructive font-semibold" : "text-muted-foreground",
      )}
    >
      {alderTekst(ageDays)}
    </span>
  );
}
